export default __webpack_public_path__ + "static/media/NU-SC300BMPQ_Spec 2.84c07b74.jpg";